module.exports = __webpack_public_path__ + "static/media/dongmami_aboutus.954b169.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dongmami_aboutus.mp4
// module id = L9Lt
// module chunks = 1